import { cn } from "@quint/ui";
import { useState } from "react";
import { Pool } from "./pool";
import { StakingCardDesktop } from "./staking-card-desktop";
import { type StakingCardDatum } from "./types";

export const StakingDesktopView = ({ data }: { data: StakingCardDatum[] }) => {
  const [selectedPool, setSelectedPool] = useState(data[0] as StakingCardDatum);

  return (
    <div className="hidden flex-grow grid-cols-2 gap-6 xl:grid">
      <div className="grid max-h-[560px] gap-6 overflow-auto pr-2">
        {data.map((d) => (
          <StakingCardDesktop
            key={d.name}
            selected={selectedPool.name === d.name}
            setSelected={setSelectedPool}
            {...d}
          />
        ))}
      </div>
      <div
        className={cn(
          "flex h-full min-h-[122px] w-full flex-col justify-between rounded-2xl p-6",
          "border-[1px] border-solid border-[#E6E8EA] dark:border-[#354856]"
        )}
      >
        <Pool pool={selectedPool} />
      </div>
    </div>
  );
};
